import React, { useMemo } from "react";
import { Box, Card, CardContent, Container, Grid, Typography } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import GroupsIcon from "@mui/icons-material/Groups";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { appTheme } from "../../../shared/theme";
import { CustomRoundButton } from "Layout/CustomButton";

const StatCard = ({ icon, value, label }) => {
  return (
    <Card
      elevation={0}
      sx={{
        height: "100%",
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.14)",
        background: "rgba(255,255,255,0.06)",
        backdropFilter: "blur(6px)",
        transition: "transform 160ms ease, background 160ms ease",
        "&:hover": {
          transform: "translateY(-2px)",
          background: "rgba(255,255,255,0.09)",
        },
      }}
    >
      <CardContent
        sx={{
          p: { xs: 2, md: 2.5 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: 1,
        }}
      >
        <CustomRoundButton aria-label={label}>{icon}</CustomRoundButton>

        <Typography
          sx={{
            color: appTheme.palette.white.main,
            fontWeight: 800,
            fontSize: { xs: 28, md: 32 },
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
          }}
        >
          {value}
        </Typography>

        <Typography
          sx={{
            color: appTheme.palette.yellow.main,
            fontSize: { xs: 14, md: 16, lg: 18 },
            textTransform: "uppercase",
            letterSpacing: 1.2,
            fontWeight: 700,
            lineHeight: 1.35,
          }}
        >
          {label}
        </Typography>
      </CardContent>
    </Card>
  );
};

export const HomeStatsSection = () => {
  const stats = useMemo(
    () => [
      {
        key: "companies",
        value: "30+",
        label: "Companies trust us",
        icon: (
          <BusinessIcon
            sx={{
              color: appTheme.palette.green.main,
              fontSize: { xs: 36, md: 44 },
            }}
          />
        ),
      },
      {
        key: "users",
        value: "676+",
        label: "Users and growing",
        icon: (
          <GroupsIcon
            sx={{
              color: appTheme.palette.green.main,
              fontSize: { xs: 36, md: 44 },
            }}
          />
        ),
      },
      {
        key: "bookings",
        value: "2,250+",
        label: "Bookings to date",
        icon: (
          <CalendarMonthIcon
            sx={{
              color: appTheme.palette.green.main,
              fontSize: { xs: 36, md: 44 },
            }}
          />
        ),
      },
    ],
    []
  );

  return (
    <Box
      component="section"
      aria-label="Platform statistics"
      sx={{
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        <Grid container spacing={2}>
          {stats.map((stat) => (
            <Grid item xs={12} md={4} key={stat.key}>
              <StatCard icon={stat.icon} value={stat.value} label={stat.label} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
